export default "__VITE_ASSET__ce432425__"